/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

/** Utilities */
import { mapDropdownOptions } from "../../../../components/finalForms/libs/mapDropdownOptions";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import { AppIcons } from "../../../../data/appIcons";
import ToastService from "../../../../services/toastService/ToastService";

/** Configuration Files */
import projectTeamFormData from "./config/ProjectTeam.data";

/** RTK Query */
import {
  useAddProjectTeamMutation,
  useLazyGetUnAssginUserListQuery,
} from "../../../../app/services/projectTeamManagementAPI";

const AddProjectTeamManagement = (props) => {
  const ref = useRef();
  /* State*/
  const [formData, setFormData] = useState(projectTeamFormData);
  // API'S Call
  const [getAllUsers, {
    isFetching: isUsersFetching,
    isSuccess: isUsersFetched,
    data: usersData
  },] = useLazyGetUnAssginUserListQuery();

  const [addProjectTeam, {
    isSuccess: isProjectTeamAdded,
    isLoading: isProjectTeamAdding,
    data: addProjectTeamData,
  },] = useAddProjectTeamMutation();

  //** useEffect's */
  useEffect(() => {
    getAllUsers(props.projectId);
  }, [props.projectId, props.isOpen]);

  useEffect(() => {
    if (isProjectTeamAdded && addProjectTeamData) {
      if (addProjectTeamData.errorMessage.includes("exists")) {
        ToastService.warning(addProjectTeamData.errorMessage);
        return;
      } else {
        ToastService.success(addProjectTeamData.errorMessage);
        backToList();
        getAllUsers(props.projectId);
      }
    }
  }, [isProjectTeamAdded, addProjectTeamData]);

  useEffect(() => {
    if (!isUsersFetching && isUsersFetched && usersData) {
      mapDropdownOptions(
        projectTeamFormData,
        "projectTeam",
        "userId",
        usersData,
        "userId",
        "userName"
      );
      setFormData({ ...projectTeamFormData });
    }
  }, [isUsersFetching, isUsersFetched, usersData]);

  //** Funcation's */
  const handleProjectTeam = () => {
    const formData = ref.current.getFormData();
    if (formData) {
      const userIds = formData.userId.join(",");
      const requestData = {
        ...formData,
        projectId: props.projectId,
        UserIds: userIds
      };
      addProjectTeam(requestData);
    }
  };

  const backToList = () => {
    props.onClose();
  };

  return (
    <>
      <div className="add-project-modal">
        <div className="row">
          <FormCreator config={formData} ref={ref} {...formData} />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="theme-btn ml-4 mt-2"
              onClick={handleProjectTeam}
              buttonText="Project Team"
              textWithIcon={true}
              iconName="material-symbols:add-rounded"
              isLoading={isProjectTeamAdding}
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </>
  );
};

AddProjectTeamManagement.propTypes = {
  projectId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
export default AddProjectTeamManagement;
